import { Component, OnInit } from '@angular/core';
import { StepType, RegistrationStepService, RegistrationStepQuery, LoggingService } from '@fgb/core';

@Component({
  selector: 'fgbcl-registration-operator-name',
  templateUrl: './registration-operator-name.component.html',
  styleUrls: ['./registration-operator-name.component.scss'],
})
export class RegistrationOperatorNameComponent implements OnInit {
  readonly stepType = StepType.OperatorName;
  hasSubmitted: boolean = false;
  operatorName: string;

  constructor(
    private registrationStepService: RegistrationStepService,
    private registrationStepQuery: RegistrationStepQuery,
    private logService: LoggingService
  ) {}

  ngOnInit() {
    const step = this.registrationStepQuery.getStep(this.stepType);
    if (!step) {
      this.logService.warning('No step data found in the store for step', this.stepType);
      return;
    }

    this._prefillExistingStepData(step.Data);
  }

  submitStep() {
    this.hasSubmitted = true;

    if (!this.operatorName) {
      return;
    }

    let stepData = {
      OperatorName: this.operatorName,
    };

    this.registrationStepService.submitRegistrationStepData(this.stepType, stepData).toPromise();
  }

  private _prefillExistingStepData(stepData?: any) {
    if (stepData) {
      this.operatorName = stepData.OperatorName;
    }
  }
}
